<section [class]="'Social Social--' + provider">
    <div class="uk-flex uk-flex-between uk-flex-middle">
        <div class="Social_Title">{{ heading }}</div>
		<a class="uk-button uk-button-primary" [href]="subscribeLink" target="_blank">{{ btntext }}</a>
	</div>
    <article class="Social_Article" *ngFor="let post of posts">
		<a class="uk-flex uk-flex-middle" [href]="post.href" target="_blank">
			<span class="Social_Img uk-flex-none" [style.background-image]="'url(' + post.image + ')'"></span>
			<span class="Social_Info">
				<span class="uk-flex uk-flex-between">
					<span class="Social_Info_Title uk-text-truncate" [title]="post.name">{{ post.name }}</span>
					<span class="Social_Info_Date">{{post.date | date:'dd.MM.y'}}</span>
				</span>
				<span class="Social_Info_Description">{{post.text}}</span>
			</span>
		</a>
	</article>
    <div *ngIf="posts.length === 0">
        <article class="Social_Article" *ngFor="let placeholder of placeLoaders">
			<a class="uk-flex uk-flex-middle">
				<span class="Social_Img uk-flex-none Placeloader"></span>
				<span class="Social_Info uk-width-1-1">
					<span class="uk-display-block">
						<span class="Social_Info_Title Placeloader">Золотой код</span>
						<span class="Social_Info_Date Placeloader">12.10.2016</span>
					</span>

					<span class="Social_Info_Description">
						<p class="Placeloader uk-margin-small">lorem</p>
						<p class="Placeloader uk-margin-small uk-margin-remove-bottom">lorem</p>
					</span>
				</span>
			</a>
		</article>
    </div>
</section>
